import { Slider } from '../modules/slider';

const sections = document.querySelectorAll('.reviews-slider');
if (sections.length > 0) {
    sections.forEach(section => {
        const slider = new Slider({
            isReviews: true,
            el: section,
            autoplay: section.getAttribute('data-autoplay'),
            breakpoints: {
                0: {
                    slidesPerView: 1,
                },
            },
        });
    });
}
